export default {
  namespaced: true,
  state: {
    selectedYear: new Date().getFullYear(),
    selectedMonth: new Date().getMonth() + 1,
    faturamentoData: null,
  },
  mutations: {
    SET_SELECTED_YEAR(state, year) {
      state.selectedYear = parseInt(year)
    },
    SET_SELECTED_MONTH(state, month) {
      state.selectedMonth = parseInt(month)
    },
    SET_FATURAMENTO_DATA(state, data) {
      state.faturamentoData = data
    },
  },
  actions: {
    setSelectedYear({ commit }, year) {
      commit('SET_SELECTED_YEAR', year)
    },
    setSelectedMonth({ commit }, month) {
      commit('SET_SELECTED_MONTH', month)
    },
    setFaturamentoData({ commit }, data) {
      commit('SET_FATURAMENTO_DATA', data)
    },
    updateFaturamentoSelections({ commit }, { year, month }) {
      commit('SET_SELECTED_YEAR', year)
      commit('SET_SELECTED_MONTH', month)
    },
  },
  getters: {
    getSelectedYear: state => state.selectedYear,
    getSelectedMonth: state => state.selectedMonth,
    getFaturamentoData: state => state.faturamentoData,
  },
}
